/**
 * The Anthropic model families Clarity names.
 *
 * A `const` object rather than a TS `enum`, and the family type is derived from its values — a
 * family added here widens `ClarityModelFamily` without a second edit.
 */
export const CLARITY_MODEL_FAMILY = {
	HAIKU: 'haiku',
	SONNET: 'sonnet',
	OPUS: 'opus',
} as const;

/** A known Anthropic model family. */
export type ClarityModelFamily = (typeof CLARITY_MODEL_FAMILY)[keyof typeof CLARITY_MODEL_FAMILY];

/** Every known family, in the order they are matched against a model id. */
export const CLARITY_MODEL_FAMILIES: readonly ClarityModelFamily[] = Object.values(CLARITY_MODEL_FAMILY);

/** Display casing for each family. */
export const CLARITY_MODEL_FAMILY_DISPLAY_NAME: Readonly<Record<ClarityModelFamily, string>> = {
	[CLARITY_MODEL_FAMILY.HAIKU]: 'Haiku',
	[CLARITY_MODEL_FAMILY.SONNET]: 'Sonnet',
	[CLARITY_MODEL_FAMILY.OPUS]: 'Opus',
};
